<script setup lang="ts">
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {QInput, useDialogPluginComponent} from "quasar";
import Translator from "@/utils/common/Translator.ts";
import {computed, onMounted, useTemplateRef} from "vue";
import {IHeaderParams} from "ag-grid-enterprise";
import TitledID = namaTypes.TitledID;

const props = defineProps<{ blockOrField?: TitledID, agHeaderParams?: IHeaderParams, entityType?: string }>()
const agHeaderParams = props.agHeaderParams;
const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const qInputArabicText = useTemplateRef<QInput>("qInputArabicText")
const qInputEnglishText = useTemplateRef<QInput>("qInputEnglishText")

function getBlockOrField() {
  return props.blockOrField || {};
}

const arabicText = computed({
  get() {
    return getBlockOrField()?.title?.arabicText;
  },
  set(value) {

    if (value && Translator.isArabic()) {
      if (agHeaderParams)
        agHeaderParams.displayName = value
    }
    let blockOrField = getBlockOrField();
    if (!blockOrField)
      return;
    if (!blockOrField.title)
      blockOrField.title = {};
    blockOrField.title.arabicText = value;
  }
})
const englishText = computed({
  get() {
    return getBlockOrField()?.title?.englishText;
  },
  set(value) {
    if (value && Translator.isEnglish()) {
      if (agHeaderParams)
        agHeaderParams.displayName = value
    }
    let blockOrField = getBlockOrField();
    if (!blockOrField)
      return;
    if (!blockOrField.title)
      blockOrField.title = {};
    blockOrField.title.englishText = value;
  }
})

onMounted(() => {
  qInputArabicText.value?.focus();
})
</script>

<template>
  <q-dialog ref="dialogRef" transition-hide="jump-down" transition-show="jump-up">
    <q-card class="tw-relative tw-w-[450px] dark:tw-bg-namaBackground-deep-dark tw-px-4 tw-py-3 !tw-rounded-xl">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-items-center tw-gap-2">
          <NamaIcon default-icon="nm-edit-text" class=""/>
          <p v-text="'Edit UI Element - '+ Translator.translateTitledId(entityType,getBlockOrField())"
             class="tw-text-lg tw-font-semibold tw-leading-none dark:tw-text-white"/>
        </div>
        <q-avatar square class="tw-size-5  tw-cursor-pointer" @click="onDialogCancel">
          <DialogCloseIcon/>
        </q-avatar>
      </div>
      <q-separator class="tw-my-3 dark:tw-bg-white/10"/>
      <q-card-section class="!tw-p-2 tw-w-full tw-flex tw-flex-col tw-gap-2 tw-items-center">
        <div class="tw-p-6 tw-pt-6 tw-pb-10  tw-rounded-md tw-w-full">
          <label v-text="Translator.translateId('arText')" class="dark:tw-text-white tw-mb-2 tw-block"/>
          <q-input
            outlined dense hide-bottom-space
            ref="qInputArabicText"
            class="nama-field-input nama-customize-dense-input nama-focused-input"
            input-class="nama-input-class"
            v-model="arabicText"
          />
          <label v-text="Translator.translateId('enText')" class="dark:tw-text-white tw-my-2 tw-block"/>
          <q-input
            outlined dense hide-bottom-space
            ref="qInputEnglishText"
            class="nama-field-input nama-customize-dense-input nama-focused-input"
            input-class="nama-input-class"
            v-model="englishText"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
